module.exports = [
	{
		type: 'image',
		id: 'bg-img', //默认允许编辑
		url: 'https://doc.efreight.cn/weapp/zjhy/static/2021-12-28/shop-poster5-1-new.png',
		css: {
			top: 0,
			left: 0,
			width: 360,
			height: 640,
		},
    },
    {
		type: 'image',
		url: 'https://doc.efreight.cn/weapp/zjhy/static/2021-12-28/shop-poster5-2-new.png',
		css: {
			top: 157,
			left: 180,
			width: 222,
            height: 88,
            originX:'center',
		},
	},
	{
		type: 'image',
		id: 'avatar',
		url: 'https://doc.efreight.cn/test/2021-12-28/avatar-new.jpg',
		css: {
			top: 27,
			left: 180,
			width: 40,
            height: 40,
            originX:'center',
			borderRadius: true,
		},
	},
	{
		type: 'text',
		id: 'title',
		text: '店铺名称',
		css: {
			top: 76,
			left: 180,
			color:'#FFB6AA',
			originX:'center',
			
		},
		editAble: true
	},
	{
		id: 'qrcode',
		type: 'qrcode',
		content: '二维码',
		css: {
			top: 526,
			left: 253,
			width: 80,
			height: 80,
			color:'#000',
		}
	},
	{
		type: 'text',
		text: '祝大家新的一年财源滚滚',
		css: {
			top: 255,
			left: 180,
			color:'#FAD495',
            fontSize: 16,
            originX:'center',
		},
		editAble: true
	},
]